function calculateShippingDate(orderDateTime, is5days = false, is7days = false, is9days = false) {
  const cutOffTime = new Date(orderDateTime);
  cutOffTime.setHours(12, 0, 0, 0);
  const orderTime = new Date(orderDateTime).getTime();
  const orderDayOfWeek = new Date(orderDateTime).getDay();
  const isWeekend = orderDayOfWeek === 0 || orderDayOfWeek === 6;

  let shippingDate = new Date(orderDateTime);

  
  if (orderTime < cutOffTime.getTime()) {
    shippingDate.setDate(shippingDate.getDate() + (0));
  } 
  else if((orderTime > cutOffTime.getTime()) && !(isWeekend)){
    shippingDate.setDate(shippingDate.getDate() + (1));
  }

  
  if(orderDayOfWeek === 0){
    shippingDate.setDate(shippingDate.getDate() + (1));
  }

  if(orderDayOfWeek === 6){
    shippingDate.setDate(shippingDate.getDate() + (2));
  }
  
  if (is5days || is7days || is9days) {
    var numberOfDays;

    if(is5days){
      numberOfDays = 5;
    }

    if(is7days){
      numberOfDays = 7;
    }

    if(is9days){
      numberOfDays = 9;
    }

    for (let i = 0; i < numberOfDays; i++) {
      if (shippingDate.getDay() === 6) { 
        shippingDate.setDate(shippingDate.getDate() + 3); 
      } 
      else {
        shippingDate.setDate(shippingDate.getDate() + 1); 
      }
    }
  }
  else{
    for (let i = 0; i < 2; i++) {
      if (shippingDate.getDay() === 6) {
            shippingDate.setDate(shippingDate.getDate() + 3);
      } 
      else {
            shippingDate.setDate(shippingDate.getDate() + 1);
      }
    }
  }

  var orderDayOfShip = shippingDate.getDay();

  if(orderDayOfShip === 6){
    shippingDate.setDate(shippingDate.getDate() + 2);
  }

  //In case of extra holidays just add up number how many would you want and remove the commenting..................
  //shippingDate.setDate(shippingDate.getDate() + 2);
  
  const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
  const dayNames = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
  const shippingDateString = `${dayNames[shippingDate.getDay()]}, ${monthNames[shippingDate.getMonth()]} ${shippingDate.getDate()}`;
  return shippingDateString;
}

function calculateShippingDateforCart(orderDateTime, is5days = false, is7days = false, is9days = false) {
  const cutOffTime = new Date(orderDateTime);
  cutOffTime.setHours(12, 0, 0, 0);
  const orderTime = new Date(orderDateTime).getTime();
  const orderDayOfWeek = new Date(orderDateTime).getDay();
  const isWeekend = orderDayOfWeek === 0 || orderDayOfWeek === 6;

  let shippingDate = new Date(orderDateTime);

  
  if (orderTime < cutOffTime.getTime()) {
    shippingDate.setDate(shippingDate.getDate() + (0));
  } 
  else if((orderTime > cutOffTime.getTime()) && !(isWeekend)){
    shippingDate.setDate(shippingDate.getDate() + (1));
  }

  
  if(orderDayOfWeek === 0){
    shippingDate.setDate(shippingDate.getDate() + (1));
  }

  if(orderDayOfWeek === 6){
    shippingDate.setDate(shippingDate.getDate() + (2));
  }
  
  if (is5days || is7days || is9days) {
    var numberOfDays;

    if(is5days){
      numberOfDays = 5;
    }

    if(is7days){
      numberOfDays = 7;
    }

    if(is9days){
      numberOfDays = 9;
    }

    for (let i = 0; i < numberOfDays; i++) {
      if (shippingDate.getDay() === 6) { 
        shippingDate.setDate(shippingDate.getDate() + 3); 
      } 
      else {
        shippingDate.setDate(shippingDate.getDate() + 1); 
      }
    }
  }
  else{
    for (let i = 0; i < 2; i++) {
      if (shippingDate.getDay() === 6) {
            shippingDate.setDate(shippingDate.getDate() + 3);
      } 
      else {
            shippingDate.setDate(shippingDate.getDate() + 1);
      }
    }
  }

  var orderDayOfShip = shippingDate.getDay();

  if(orderDayOfShip === 6){
    shippingDate.setDate(shippingDate.getDate() + 2);
  }

  //In case of extra holidays just add up number how many would you want and remove the commenting..................
  //shippingDate.setDate(shippingDate.getDate() + 1);
  
  const monthNames = ["J-", "F-", "M-", "A-", "M-", "J-", "J-", "A-", "S-", "O-", "N-", "D-"];
  const dayNames = ["S-", "M-", "T-", "W-", "T-", "F-", "S-"];
  const shippingDateString = `${dayNames[shippingDate.getDay()]}${monthNames[shippingDate.getMonth()]}${shippingDate.getDate()}`;
  return shippingDateString;
}

function showShippingDate() {
  const orderDateTime = new Date();
  const shippingDateText = document.getElementById('shipping_date_text');
  const is5days = shippingDateText.dataset.fivedays === 'true';
  const is7days = shippingDateText.dataset.sevendays === 'true';
  const is9days = shippingDateText.dataset.ninedays === 'true';
  const shippingDate = calculateShippingDate(orderDateTime, is5days, is7days, is9days);
  document.getElementById('shipping_date').textContent = shippingDate;
  shippingDateText.style.display = 'block';
  const shippingDatecart = calculateShippingDateforCart(orderDateTime, is5days, is7days, is9days);
  document.getElementById('shipping-detail-date-cart').value = shippingDatecart;
}

function showPopup() {
  const popupTrigger = document.getElementById("popup_trigger");
  const popup = document.getElementById("popup");
  let popupVisible = false;

  function displayPopup(){
    if (!popupVisible) {
      popup.style.display = "block";
      popupVisible = true;
    } 
    else {
      popup.style.display = "none";
      popupVisible = false;
    }
  }


  function hidePopup() {
    popup.style.display = "none";
    popupVisible = false;
  }

  popupTrigger.addEventListener("mouseover", displayPopup);
  popupTrigger.addEventListener("mouseout", hidePopup);


  
  popupTrigger.addEventListener("click", displayPopup);
  
  popup.addEventListener("click", function(event) {
    event.stopPropagation();
  });
}

showShippingDate();
showPopup();